import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import 'typeface-roboto/index.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken1, // #1E88E5
    secondary: colors.grey.lighten3, // #FFCDD2
    accent: colors.shades.black, // #3F51B5
    info: colors.shades.white,
    sidedrawer: colors.grey.lighten5,
    euflag: colors.indigo.darken1,
    warning: colors.red.darken2
  }
})

Vue.use(Vuetify, {
  iconfont: 'mdi'
})



// WEBPACK FOOTER //
// ./src/material.js